import React from 'react'
import { Button, Card, Grid } from 'semantic-ui-react'
import SimpleConfirm from '../common/simpleConfirm'



const User = ({ user, onEditUser, onDeleteUser, formConfigData }) => {


  const [showDeleteConfirm, toggleDeleteConfirm] = React.useState(false)
  const onUserDeleteConfirmed = (key) => {
    onDeleteUser(key)
    toggleDeleteConfirm(false)
  }
  const onUserDeleteAborted = (key) => {
    toggleDeleteConfirm(false)
  }

  const formatter = (s, charcount) => {
    let c = charcount ?? 30

    if (s == null) return "" 
    if (s.length < c) return s 

    return s.slice(0,c).concat("..")
  }


  const displayCard_HeaderMajor = (user, config) => {
    let headertext = ""
    let sorted = config.displayCard.header_major.sort((c, p) => {return c.displayOrder -  p.displayOrder} )
    sorted.forEach((element) => {
      headertext += user[element.fieldName] + " "
    })
    return headertext
  }

  const displayCard_HeaderMinor = (user, config) => {
    let headertext = ""
    let sorted = config.displayCard.header_minor.sort((c, p) => {return c.displayOrder -  p.displayOrder} )
    sorted.forEach((element) => {
      headertext += user[element.fieldName] + " "
    })
    return headertext
  }

  const displayCard_InfoFields = (user, config) => {
    let sorted_fields = config.displayCard.info_fields.sort((c, p) => {return c.displayOrder -  p.displayOrder} )
    return sorted_fields.map( (field, index) => 
        user.hasOwnProperty(field.fieldName) && <p key={index}>{formatter(user[field.fieldName])}</p>
    );
  }



  return (
    <Card className="puzzel-card-shadow">

      {/* {
        showDeleteConfirm &&
        <SimpleConfirm
          id={user.key}
          show={showDeleteConfirm}
          header={"Bekräfta borttagning!"}
          text={`Är du säker på att du vill ta bort ${user.name}?`}
          confirmText={"Ta bort användaren"}
          abortText={"Stäng"}
          onConfirm={(key) => { onUserDeleteConfirmed(key) }}
          onAbort={(key) => { onUserDeleteAborted(key) }}
        />
      } */}

          <Card.Content>
            <Card.Header>
              {displayCard_HeaderMajor(user, formConfigData)}
            </Card.Header>
            <Card.Description>
              {displayCard_HeaderMinor(user, formConfigData)}
            </Card.Description>
          </Card.Content>
          <Card.Content>
            {displayCard_InfoFields(user, formConfigData)}
          </Card.Content>

          <Card.Content>
            <Grid container columns={1} >
              <Grid.Column>
                <Button
                  compact
                  size='mini'
                  color='green'
                  onClick={() => { onEditUser(user.key) }}
                >
                  Editera
                </Button>
              </Grid.Column>
              
              {/* Customers should not be able to delete users at this stage. they might in the future */}
              {/* <Grid.Column>
                <Button
                  compact
                  size='mini'
                  color='red'
                  onClick={() => { toggleDeleteConfirm(true) }}
                >
                  Ta bort
                </Button>
              </Grid.Column> */}
            </Grid>
          </Card.Content>
        </Card>
    
  ) 
}

export default User;



